module.exports = __webpack_public_path__ + "img/5.c1258059.png";